import { render, staticRenderFns } from "./ModifyRDNSZoneModal.vue?vue&type=template&id=a93c2a50&"
import script from "./ModifyRDNSZoneModal.vue?vue&type=script&lang=js&"
export * from "./ModifyRDNSZoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports